import { render, staticRenderFns } from "./DisplayDash.vue?vue&type=template&id=2f01b869&scoped=true"
import script from "./DisplayDash.vue?vue&type=script&lang=js"
export * from "./DisplayDash.vue?vue&type=script&lang=js"
import style0 from "./DisplayDash.vue?vue&type=style&index=0&id=2f01b869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f01b869",
  null
  
)

export default component.exports